// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { map } from "lodash";

// Redux
import { connect } from "react-redux";

// subComponents
import FieldCard from "../FieldCard";

// Styles
import styles from "./styles.module.css";

const DynamicFields = ({
	isEditable,
	companyFieldsData,
	companyFieldsInputHandler = () => {},
	noSendQuestion,
	questionsLanguage,
	windowSize = {},
	disabledStyle = false,
	groupsToken,
	token,
}) => {
	const renderCompanyFields = (fieldsData) => {
		const fieldCardsList = map(fieldsData, (fieldData, index) => {
			return (
				<FieldCard
					key={index}
					fieldData={fieldData}
					companyFieldsInputHandler={companyFieldsInputHandler}
					isEditable={isEditable}
					noSendQuestion={noSendQuestion}
					questionsLanguage={questionsLanguage}
					windowSize={windowSize}
					disabledStyle={disabledStyle}
					groupsToken={groupsToken}
					token={token}
				/>
			);
		});
		return fieldCardsList;
	};

	return <div className={styles.container}>{renderCompanyFields(companyFieldsData)}</div>;
};

DynamicFields.propTypes = {
	companyFieldsInputHandler: PropTypes.func,
	companyFieldsData: PropTypes.any,
	isEditable: PropTypes.bool,
	noSendQuestion: PropTypes.bool,
	questionsLanguage: PropTypes.string,
	windowSize: PropTypes.object,
	disabledStyle: PropTypes.bool,
	groupsToken: PropTypes.array,
	token: PropTypes.string,
};

function mapStateToProps({ company, user }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}

export default connect(mapStateToProps)(DynamicFields);
